<template>
    <div>
        <h1 class="hidden-title" style="display: none">My Wishlist</h1>

        <Banner />

        <div class="kts-wishlist__content">
            <div class="container">
                <HeaderWishlist />
                <ListProduct :dataListing = "dataListing" :dataLoadMore = "dataLoadMore"  @onRemove="handleRemoveItem" :check_remove="true"/>
            </div>
        </div>
        <Loading v-if="isLoading" />
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/wishlist/_wishlist.scss";
    .kts-wishlist__content {
        .wishlist_custom {
            .item_wishlist {
                .w_price {
                    padding: 0 !important;
                }
            }
            .listing-products {
                row-gap: 45px;
            }
        }
    }
</style>

<script setup lang="ts">
    import Banner from "~/components/Wishlist/Banner.vue"
    import HeaderWishlist from "~/components/Wishlist/HeaderWishlist.vue"
    import ListProduct from "~/components/Wishlist/ListProduct.vue"
    import type { IAPIResponseError } from '~/types/apiResponseError';

    const { pushToDataLayer, pushPageTypeToDataLayer } = useCustomGtm();
    const router = useRouter();
    const { $ajax } = useNuxtApp();
    const isLoading = ref(true);
    const userStore = useUserStore();
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();

    interface IResponse {
        success: boolean;
        data: any[];
    };
    const dataListing = ref();
    const list_id_wishlist = ref();
    const dataLoadMore = ref();

    const handleRemoveItem =(id: number) => {
        const indexDataListing = dataListing.value.findIndex( x => +x.product_id == id);
        const indexLoadMore = dataLoadMore.value.findIndex( x => +x.product_id == id);

        if(indexDataListing >= 0){
            dataListing.value.splice(indexDataListing, 1);
            if(dataLoadMore.value?.length){
                dataListing.value.push(dataLoadMore.value[0]);
                dataLoadMore.value.splice(0, 1);
            }
        }
        if(indexLoadMore >= 0){
            dataLoadMore.value.splice(indexDataListing, 1);
        }
    }
    const getData = async () => {
        isLoading.value = true;
        try {
            const rawWishlist = toRaw(list_id_wishlist.value);
            const queryString = rawWishlist.map(id => `idWishlist[]=${id}`).join('&');
            const response = await $ajax.get<IResponse>(`wp-json/skj/v1/wishlist/user?${queryString}`,{ headers: {"Authorization": `Bearer ${userStore.csrf}`,'X-API-Server': userStore.csrf_server} });
            if(response.success){
                dataListing.value = response.dataListing;
                dataLoadMore.value = response.dataLoadMore;
            }
            isLoading.value = false;
        } catch (error) {
            isLoading.value = false;
            if (error && typeof error === 'object' && 'data' in error) {
                const errorData = error.data as IAPIResponseError;
                console.log('getWhislistErrorCatch', errorData.code);
            } else {
                console.log('Unexpected error:', error);
            }
        }
    }
    // getData();
    onMounted(() => {
        // console.log('login_userStore', userStore.user);
        // console.log('login_userStore22', userStore.user.wishlist_sharekey);
        if (userStore.isLogin && userStore.user.wishlist_sharekey) {
            if(locale.value == 'ms-my'){
                router.push(`/ms-my/wishlist/${userStore.user.wishlist_sharekey}`);
            }else {
                router.push(`/wishlist/${userStore.user.wishlist_sharekey}`);
            }
        }else{
            // console.log('not_login');
            if (typeof window !== 'undefined') {
                const list_wishlist = JSON.parse(localStorage.getItem('list_wishlist')) || [];
                if (list_wishlist.length > 0) {
                    list_id_wishlist.value = list_wishlist;
                }
                getData();
            }
        }

        const routeslug = useRoute(); // Get the current route
        const pathSegments = routeslug.path.split('/').filter(segment => segment);
        const pageType = 'wishlist page';
        const hierachy1 = pathSegments[0] || 'n/a';
        const hierachy2 = pathSegments[1] || 'n/a';
        const hierachy3 = 'n/a';
        pushPageTypeToDataLayer(pageType, {
            hierachy1,
            hierachy2,
            hierachy3,
        });
    })
</script>
